import klydoApiClient, { Klydo } from '../api/klydo';
import useKlydoQuery, { UseKlydoQueryResult } from './useKlydoQuery';

type UseKlydosByDateQueryParams = {
  date: Date;
  enabled?: boolean;
};

const useKlydosByDateQuery = ({
  date,
  enabled = true,
}: UseKlydosByDateQueryParams): UseKlydoQueryResult<Klydo[]> => {
  return useKlydoQuery({
    queryKey: ['klydos-by-date', date.toISOString()],
    queryFn: () => klydoApiClient.getKlydosByPublicationDate(date),
    enabled,
  });
};

export default useKlydosByDateQuery;
